import SuccessMessageCard from "../../../../components/common/success-message-card/SuccessMessageCard";
import { ReactComponent as SuccessIcon } from "../../../../assests/payment-success-icon.svg";
import { ReactComponent as Arrow } from "../../../../assests/back-arrow.svg";
import { useNavigate } from "react-router-dom";
import "./DocusignSuccessPage.css";
import { ArrowRightOutlined } from "@ant-design/icons";
import {
  addBreadcrumb,
  removeBreadCrumbsByCondition,
} from "../../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { useDispatch } from "react-redux";
import BreadcrumbNav from "../../../../components/common/bread-crumbs/BreadCrumb";
import { useMediaQuery } from "react-responsive";
import { Divider } from "antd";

const DocuSignSuccessPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 769 });

  // navigating to insertion order when there are no campaigns in checkout
  const goToMyCampaigns = () => {
    const title = "InsertionOrderCampaigns";
    const path = "/buyer/mycampaigns?segment=insertion_order";
    dispatch(
      removeBreadCrumbsByCondition((crumb) => {
        return crumb.title === "Campaign Purchase";
      }),
    );
    dispatch(addBreadcrumb({ title, path }));
    navigate("/buyer/mycampaigns?segment=insertion_order");
  };
  return (
    <>
      <div className="docusign-success-container">
        <SuccessMessageCard
          icon={SuccessIcon}
          header={"Docusign Successful"}
          onButtonClick={goToMyCampaigns}
          infoText={
            <div>
              Docusign has been successfully completed and has been moved to
              insertion order. No other campaigns found in checkout. You can
              track progress under My Campaigns
              <span>
                <ArrowRightOutlined />
              </span>
              Insertion Order
            </div>
          }
          buttonText={"Go to Insertion Order Campaigns"}
        />
      </div>
    </>
  );
};

export default DocuSignSuccessPage;
